import React, { useState } from "react";
import "./Contact.css";
import { MapPin, Mail, Phone } from "lucide-react";

const Contact = () => {
  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // success / error message

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const res = await fetch("https://node.aattumtpl.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        setStatus("✅ Message sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" }); // reset form
      } else {
        setStatus("❌ " + data.message);
      }
    } catch (error) {
      console.error(error);
      setStatus("❌ Something went wrong. Please try again later.");
    }
  };

  return (
    <section className="contact-section">
      <h2 className="contact-title">CONTACT</h2>
      <p className="contact-subtitle">
        Have queries about Talent Premier League? We’re here to help!
      </p>

      <div className="contact-container">
        {/* LEFT SIDE */}
        <div className="contact-info">
          <div className="info-item">
            <div className="icon-circle">
              <MapPin size={22} />
            </div>
            <div>
              <h4>Location</h4>
              <p> No. 20/14, Kalaivanar Street,
                Sapthagiri Colony,
                Jafferkhanpet,
                Chennai- 600 083.</p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon-circle">
              <Mail size={22} />
            </div>
            <div>
              <h4>Email</h4>
              <p>admin@aattumtpl.com </p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon-circle">
              <Phone size={22} />
            </div>
            <div>
              <h4>Call</h4>
              <p>+91 93848 20659</p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <input
            type="text"
            name="subject"
            placeholder="Subject"
            className="full-width"
            value={formData.subject}
            onChange={handleChange}
            required
          />

          <textarea
            rows="6"
            name="message"
            placeholder="Message"
            className="full-width"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" className="submit-btn">
            <span>Send Message</span>
          </button>

          {/* Status Message */}
          {status && <p className="status-text">{status}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
